/** Public marketing copy for /ai-chat (non-technical). */

export const aiChatContent = {
  eyebrow: "AI chat for your website",
  title: "Answers from your business - not the whole internet.",
  lead:
    "Put a helpful chat assistant on your site that knows your policies, products, and customers. It stays in your lane, runs behind secure access, and shows you how it’s performing.",
  heroPoints: [
    "Fits WordPress, React, TypeScript, and most modern sites",
    "Grounded in your documents and business data",
    "Gated, guarded, and measurable from day one",
  ],
  features: [
    {
      id: "embed",
      title: "Lives where your customers are",
      body:
        "Add chat to your existing site - whether you run WordPress, a React or TypeScript app, a static marketing page, or another common frontend. We handle the assistant; you keep your design.",
      icon: "embed",
    },
    {
      id: "knowledge",
      title: "A knowledge base it can trust",
      body:
        "Upload manuals, FAQs, policies, and help articles. The bot pulls from that library so replies reflect what you actually published - not random web guesses.",
      icon: "knowledge",
    },
    {
      id: "business",
      title: "Tuned to how you operate today",
      body:
        "Connect deals, promotions, product updates, and customer records so the assistant knows what you’re offering right now and who it’s talking to - without dumping private data into every answer.",
      icon: "business",
    },
    {
      id: "secure",
      title: "Contained, secure, and gated",
      body:
        "Guardrails keep conversations on topic. Access is controlled by token, request, or session rules so only the right visitors - or your team - can use the bot.",
      icon: "secure",
    },
  ],
  platforms: {
    title: "Works with the site you already have",
    body:
      "No need to rebuild from scratch. We integrate with the stack you’re on and keep the widget on-brand.",
    chips: [
      "WordPress",
      "React",
      "TypeScript",
      "Static HTML",
      "Vue",
      "Other frameworks",
    ],
  },
  models: {
    title: "The right brain for your brand",
    body:
      "Start with trusted, popular AI models for fast rollout - or train a custom model on your tone, terminology, and workflows when you want something uniquely yours.",
    options: [
      {
        label: "Popular models",
        hint: "Quick to launch, strong out of the box",
      },
      {
        label: "Custom fine-tuned",
        hint: "Speaks your language and rules",
      },
    ],
  },
  access: {
    title: "You decide who gets in",
    body:
      "Every conversation can be tied to a secure token, approved request, or signed-in session - so public visitors, logged-in customers, and internal staff each see what they should.",
    points: [
      "Rate limits and abuse protection",
      "Scoped answers by audience",
      "Audit-friendly session handling",
    ],
  },
  analytics: {
    title: "See how your bot is doing",
    subtitle:
      "Track conversations, satisfaction, and gaps - so you improve scripts and content instead of guessing.",
    businessName: "Your business",
    metrics: {
      conversations: "2,840",
      resolved: "78%",
      avgResponse: "1.2s",
    },
    activeChats: [
      { id: "Visitor …9f2a", state: "Answering", snippet: "Asking about warranty on Model X" },
      { id: "Member …41bc", state: "Logged in", snippet: "Checking order status" },
    ],
    recent: [
      {
        id: "Session …88d1",
        topic: "Pricing",
        outcome: "Resolved",
        response: "Shared current promo from knowledge base",
        time: "3 min ago",
      },
      {
        id: "Session …70aa",
        topic: "Returns",
        outcome: "Handed off",
        response: "Escalated to support queue",
        time: "12 min ago",
      },
      {
        id: "Session …55c0",
        topic: "Hours & location",
        outcome: "Resolved",
        response: "Answered from FAQ library",
        time: "28 min ago",
      },
    ],
    liveBadge: "Live",
  },
  cta: {
    primary: "Plan your site assistant",
    secondary: "View pricing",
  },
};
